import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=19dd6bca"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\sdr\\KB\\Knowledge-base\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19dd6bca')) {
      api.createRecord('19dd6bca', component.options)
    } else {
      api.reload('19dd6bca', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=19dd6bca", function () {
      api.rerender('19dd6bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TiptapEditor/TiptapComponents/Preview/Preview.vue"
export default component.exports